import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Simple Tom Select for standard dropdowns (no remote loading, no create)
export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {
      maxItems: 1,
      create: false,
      allowEmptyOption: true
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
